import classNames from "classnames";
import { useState } from "react";

import ProLoginModal from "components/proLoginModal/proLoginModal";
import type { Report } from "content-ui/intelligence/types";
import { PaywallData } from "lib/types/datoBlocks";
import styles from "./reports.module.css";
import Card from "./card";

export interface ReportsProps {
  reports?: Report[];
  paywall: PaywallData | null;
  className?: string;
}

const Reports = ({ reports, className, paywall }: ReportsProps) => {
  const innerClasses = classNames(styles.innerContainer, "mt-5xl pb-3xl");
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className={className}>
      <div className={innerClasses}>
        {reports &&
          reports.map((report, index) => (
            <Card key={index} report={report} openModal={setIsModalOpen} />
          ))}
      </div>
      {paywall && (
        <ProLoginModal
          paywall={paywall}
          isOpen={isModalOpen}
          setIsOpen={setIsModalOpen}
          variant="reports"
        />
      )}
    </div>
  );
};

export default Reports;
